export default {
  home: {
    title: 'ホーム',
    welcome: '私のウェブサイトへようこそ'
  },
  about: {
    title: '概要',
    description: 'これはVue.jsで構築された多言語ウェブサイトです'
  },
  navigation: {
    home: 'ホーム',
    about: '概要',
    language: '言語',
    languageChose: '言語選択',
    en: '英語',
    zh: '中国語',
    ja: '日本語',
    getScheme: 'ソリューションを取得',
    solution: 'ソリューション',
    joinType: '入居方法',
    joinNow: '今すぐ参加',
    aboutUs: '私たちについて',
    businessModel: 'ビジネスモデル'
  },
  notFound: {
    title: 'ページが見つかりません',
    message: 'あなたが探しているページは存在しません'
  }
}